/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';
import { Fade } from 'react-awesome-reveal';

// import Services data first to satisfy import/order lint rule
import { Services } from 'json/landingPageData';
import CTAFloatCard from 'components/CTAFloatCard';

import Button from '../elements/Button';
// background used in original discuss
import BgImage from '../assets/images/hero/services.png';

/* small slugify util used in Header/App */
function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')        // spaces/underscores -> dash
    .replace(/[^\w-]+/g, '')        // remove non-word chars except dash
    .replace(/--+/g, '-');          // collapse multiple dashes
}

/**
 * Discuss component with separate services cards section above the hero image section.
 * - Uses Services array from landingpagedata.js (each item: title, imageUrl, animation, optional description)
 * - Cards match LandingPage card style: image on top, title, description, "Learn more →"
 */
export default function Discuss() {
  return (
    <>
      {/* ===== NEW SEPARATE SERVICES SECTION (ABOVE IMAGE) ===== */}
      <section className="container mx-auto py-16 px-6">
        <h2 className="text-4xl sm:text-5xl font-bold text-theme-blue text-center mb-4">
          Our IT Services
        </h2>
        <p className="text-gray-500 text-center mb-12 max-w-2xl mx-auto">
          Comprehensive IT solutions designed to help your business grow, stay secure, and operate efficiently.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Services.map((item, index) => {
            const title = item.title || item.name || `Service ${index + 1}`;
            const img = item.imageUrl || item.img || null;
            const desc = item.description || item.desc || 'Comprehensive IT solutions designed to help your business grow, stay secure, and operate efficiently.';

            return (
              <div key={title} className="group">
                <Button type="link" href={`/services/${slugify(title)}`} className="block">
                  <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition duration-300 hover:scale-105">
                    {/* Top image */}
                    {img ? (
                      <div className="w-full h-44 rounded-t-2xl overflow-hidden">
                        <img src={img} alt={title} className="w-full h-full object-cover" />
                      </div>
                    ) : (
                      <div className="w-full h-44 flex items-center justify-center bg-gray-50">
                        <svg className="w-16 h-16 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V7" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V4h8v3" />
                        </svg>
                      </div>
                    )}

                    {/* Content */}
                    <div className="p-6">
                      <h3 className="text-theme-blue text-xl font-semibold mb-2">{title}</h3>
                      <p className="text-gray-500 text-sm mb-4">{desc}</p>

                      <div className="text-theme-purple font-medium text-sm">
                        Learn more →
                      </div>
                    </div>
                  </div>
                </Button>
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex justify-center">
          <Button href="/services" type="link" className="px-8 py-3 bg-theme-purple text-white rounded-full shadow-lg">
            Explore All Services
          </Button>
        </div>
      </section>
      {/* ===== END OF NEW SERVICES SECTION ===== */}

      {/* ===== ORIGINAL DISCUSS HERO (background image + overlay + content) ===== */}
      <Fade direction="up" triggerOnce>
        <section className="relative w-full overflow-hidden">

          {/* TOP CURVED SHAPE */}
          <div className="absolute top-0 w-full overflow-hidden leading-[0] z-10">
            <svg
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
              className="w-full h-[90px] sm:h-[120px]"
            >
              <path
                d="M0,80 C300,0 900,140 1200,40 L1200,0 L0,0 Z"
                fill="#ffffff"
              />
            </svg>
          </div>

          {/* BACKGROUND */}
          <div className="relative w-full min-h-[520px] sm:min-h-[600px] lg:min-h-[900px] flex items-center">

            {/* Background Image */}
            <img
              src={BgImage}
              alt="Discuss background"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />

            {/* Overlay */}
            <div className="absolute inset-15 bg-gradient-to-r from-black/70 via-black/55 to-black/40 sm:from-black/60 sm:via-black/45 sm:to-black/30" />

            {/* CONTENT */}
            <div className="relative z-20 w-full px-5 sm:px-10 lg:px-20">
              <div className="max-w-6xl mx-auto">

                {/* Title + Button */}
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 mb-6 sm:mb-10">

                  <h1 className="text-white font-semibold leading-tight
                    text-3xl
                    sm:text-4xl
                    md:text-5xl
                    lg:text-6xl
                    max-w-3xl"
                  >
                    An IT Partner That Makes Your Life Easier.
                  </h1>

                  <Button
                    href="/contact"
                    type="link"
                    className="bg-green-500 text-white text-base sm:text-lg lg:text-xl
                      px-6 sm:px-10
                      py-4 sm:py-5
                      rounded-full shadow-xl
                      w-fit
                      transform transition duration-300 hover:scale-105"
                  >
                    Contact Us Today!
                  </Button>
                </div>

                {/* Description */}
                <p className="font-light text-white max-w-3xl
                  text-base
                  sm:text-lg
                  lg:text-xl
                  leading-relaxed"
                >
                  Whether you&apos;re overwhelmed with day-to-day IT tasks or planning a project
                  you&apos;re unsure how to start, we partner with you to deliver IT services
                  that drive real business growth. DNS Computer provides Managed IT Services
                  and Technology Consulting for businesses nationwide.
                </p>

              </div>
            </div>
          </div>
        </section>
      </Fade>

      {/* ===== END ORIGINAL DISCUSS HERO ===== */}
      {/* ===== CTA FLOATING CARD ===== */}
      <CTAFloatCard
        title="Get started today!"
        description="Don’t wait to take control of your IT. Schedule your free consultation today, and start building a stronger, more resilient IT foundation for your business."
        buttonText="BOOK A CONSULTATION"
        buttonLink="/book-consultation"
      />
        {/* ===== END CTA FLOATING CARD ===== */}

    </>
  );
}
